// extracted by mini-css-extract-plugin
module.exports = {"PseudoTable":"PseudoTable__3oUSF"};